import { Link } from "react-router-dom";
import { MaskedLine } from "./Reveal";

export default function Footer() {
    return (
        <footer className="border-t border-paper/15 bg-ink px-6 pb-8 pt-16 text-paper md:px-12 md:pt-24">
            <MaskedLine>
                <svg viewBox="0 0 1344 200" className="block w-full" aria-hidden="true" data-testid="footer-wordmark">
                    <text
                        x="0"
                        y="185"
                        textLength="1344"
                        lengthAdjust="spacingAndGlyphs"
                        fill="#F4F5F0"
                        style={{ fontFamily: "'Archivo', system-ui, sans-serif", fontWeight: 900, fontStretch: '118%', fontSize: '250px', letterSpacing: '-0.04em' }}
                    >
                        ECOHOUSE
                    </text>
                </svg>
            </MaskedLine>
            <div className="mt-14 flex flex-col gap-3 border-t border-paper/15 pt-6 font-mono text-[11px] uppercase tracking-[0.15em] text-paper/60 md:flex-row md:items-center md:justify-between">
                <span data-testid="footer-copyright">© 2026 Ecohouse S.r.l.s.</span>
                <span data-testid="footer-piva">P.IVA 02779610027</span>
                <Link
                    to="/privacy"
                    data-testid="footer-privacy-link"
                    className="underline underline-offset-4 transition-colors hover:text-paper"
                >
                    Privacy policy
                </Link>
            </div>
        </footer>
    );
}
